import type { ApplicationNotification, NotificationAdapter } from "../notifications-panel.types";
import { createEventNotificationAdapter } from "./event-notification.adapter";
import { createDefaultNotificationAdapter } from "./default-notification.adapter";

export const createNotificationAdapter = (notification: ApplicationNotification): NotificationAdapter =>
  createEventNotificationAdapter(notification) ?? createDefaultNotificationAdapter(notification);

export const getNotificationAdapter = createNotificationAdapter;
